/* global window */

(() => {
  class ServiceRepairSerialHelpDialog {
    constructor({ config = {}, escapeHtml, escapeAttribute }) {
      this.config = config;
      this.escapeHtml = escapeHtml;
      this.escapeAttribute = escapeAttribute;
    }

    render() {
      const heading = this.config.heading || 'Gdzie znaleźć numer seryjny?';
      const closeLabel = this.config.closeLabel || 'Zamknij';
      const poweredOnItems = this.getItems(this.config.poweredOnItems);
      const poweredOffItems = this.getItems(this.config.poweredOffItems);

      return `
        <div class="service-repair-page__dialog-layer" role="presentation">
          <button
            class="service-repair-page__dialog-scrim"
            type="button"
            aria-label="${this.escapeAttribute(closeLabel)}"
            data-wizard-serial-help-close
          ></button>
          <section
            class="service-repair-page__serial-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="service-repair-serial-help-title"
          >
            <button
              class="service-repair-page__dialog-close"
              type="button"
              aria-label="${this.escapeAttribute(closeLabel)}"
              data-wizard-serial-help-close
            >
              ${this.renderCloseIcon()}
            </button>
            <div class="service-repair-page__serial-dialog-content">
              <h2 id="service-repair-serial-help-title">${this.escapeHtml(heading)}</h2>
              <div class="service-repair-page__serial-dialog-copy">
                ${this.config.intro ? `<p>${this.escapeHtml(this.config.intro)}</p>` : ''}
                ${poweredOnItems.length > 0 ? this.renderList(poweredOnItems) : ''}
                ${this.config.poweredOffIntro ? `<p>${this.escapeHtml(this.config.poweredOffIntro)}</p>` : ''}
                ${poweredOffItems.length > 0 ? this.renderList(poweredOffItems) : ''}
              </div>
            </div>
          </section>
        </div>
      `;
    }

    getItems(items) {
      return Array.isArray(items) ? items.map((item) => String(item || '').trim()).filter(Boolean) : [];
    }

    renderList(items) {
      return `
        <ul>
          ${items.map((item) => `<li>${this.escapeHtml(item)}</li>`).join('')}
        </ul>
      `;
    }

    renderCloseIcon() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" aria-hidden="true" focusable="false">
          <circle cx="18" cy="18" r="18" fill="#F2F2F2"/>
          <path d="M13.5 13.5L22.5 22.5M22.5 13.5L13.5 22.5" stroke="#595959" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;
    }
  }

  window.ServiceRepairSerialHelpDialog = ServiceRepairSerialHelpDialog;
})();
